import classNames from "classnames";
import "./index.scss";

interface IProps {
  theme?: "light" | "dark";
  style?: string;
  onClick?: () => void;
  isDisable?: boolean;
}

export const NavLeftArrow = ({ theme, style, onClick, isDisable }: IProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames({ [`${style}`]: true }, "arrow")}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="16"
        viewBox="0 0 9 16"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.34877 1.40683C7.65269 0.718214 6.53017 0.72427 5.84155 1.42035L0.551632 6.76766C-0.136982 7.46374 -0.130926 8.58626 0.565157 9.27488L5.91246 14.5648C6.60855 15.2534 7.73107 15.2474 8.41968 14.5513C9.1083 13.8552 9.10224 12.7327 8.40616 12.0441L4.31922 8.00098L8.3623 3.91405C9.05091 3.21796 9.04486 2.09544 8.34877 1.40683Z"
          fill={
            isDisable
              ? theme === "light"
                ? "#BCBCBD"
                : "#7C7C7C"
              : theme === "light"
                ? "#3272BE"
                : "#329EE2"
          }
        />
      </svg>
    </div>
  );
};
